import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  bannerTitle: {
    description: 'Upsell banner title to promote enhanced returns',
    defaultMessage: 'Upgrade your plan to unlock the Return Portal and other premium features',
    id: 'PKe3Da',
  },
  bannerSubtitle: {
    description: 'Upsell banner subtitle to promote enhanced returns',
    defaultMessage: 'Not all Return & Exchanges features are available under your current subscription plan.',
    id: 'gm9OO+',
  },
  learnMore: {
    description: 'Learn more button text for enhanced returns upsell banner',
    defaultMessage: 'Learn more',
    id: 'fKrd9+',
  },
  upgrade: {
    description: 'Upgrade button text for enhanced returns upsell banner',
    defaultMessage: 'Upgrade',
    id: 'Q3zDCu',
  },
});
